import api from './api';
import { PaymentResponse, SinglePaymentResponse, PaymentStatus, PaymentMethod, RefundStatusResponse } from '../types/payment';

export const getPayments = async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    paymentStatus?: PaymentStatus;
    paymentMethod?: PaymentMethod;
}): Promise<PaymentResponse> => {
    const response = await api.get('/payments', { params });
    return response.data;
};

export const getPaymentById = async (id: string): Promise<SinglePaymentResponse> => {
    const response = await api.get(`/payments/${id}`);
    return response.data;
};

export const refundPayment = async (paymentId: string, reason?: string): Promise<SinglePaymentResponse> => {
    const response = await api.post('/payments/refund', { paymentId, reason });
    return response.data;
};

export const getRazorpayRefundStatus = async (paymentId: string): Promise<RefundStatusResponse> => {
    const response = await api.get(`/payments/${paymentId}/refund-status`);
    return response.data;
};
